(function($) {
    $.fn.circleTooltip = function(options) {
        // Default settings
        var settings = $.extend({
            backgroundColor: '#333',
            textColor: '#fff',
            fontSize: '14px',
            padding: '12px 12px',
            borderRadius: '8px',
            maxWidth: '240px'
        }, options);

        // Store all tooltips for later reference
        var allTooltips = [];

        return this.each(function() {
            var $element = $(this);
            if ($element.data('tooltip-initialized')) return;
            $element.data('tooltip-initialized', true);

            // Create tooltip element
            var $tooltip = $('<div class="hotspot-text"></div>');
            var tooltipText = $element.data('text') || 'No tooltip text provided';
            
            // Style the tooltip
            $tooltip.css({
                position: 'absolute',
                backgroundColor: settings.backgroundColor,
                color: settings.textColor,
                fontSize: settings.fontSize,
                padding: settings.padding,
                borderRadius: settings.borderRadius,
                maxWidth: settings.maxWidth,
                pointerEvents: 'none',
                zIndex: 9999
            }).text(tooltipText);

            // Append to body and add to allTooltips array
            $('body').append($tooltip);
            allTooltips.push($tooltip);

            // Set initial state with GSAP
            gsap.set($tooltip, { autoAlpha: 0, y: 15 });

            // Function to hide all tooltips
            function hideAllTooltips(exceptThis) {
                allTooltips.forEach(function($tip) {
                    if ($tip !== exceptThis) {
                        gsap.to($tip, {
                            autoAlpha: 0,
                            y: 15,
                            duration: 0.3,
                            ease: 'back.in(1)',
                            overwrite: 'auto' // Ensures any ongoing animations are killed
                        });
                    }
                });
            }

            // Hover events
            $element.on({
                mouseenter: function() {
                    //hideAllTooltips($tooltip); // Hide all other tooltips
                    positionTooltip();
                    gsap.to($tooltip, {
                        autoAlpha: 1,
                        y: 0,
                        duration: 0.3,
                        ease: 'back.out(3)',
                        overwrite: 'auto'
                    });
                },
                mouseleave: function() {
                    gsap.to($tooltip, {
                        autoAlpha: 0,
                        y: 15,
                        duration: 0.3,
                        ease: 'back.in(1)'
                    });
                }
            });

            // Function to position tooltip and keep it in viewport
            function positionTooltip() {
                var elementPos = $element.offset();
                var elementWidth = $element.outerWidth();
                var elementHeight = $element.outerHeight();
                var tooltipWidth = $tooltip.outerWidth();
                var tooltipHeight = $tooltip.outerHeight();
                var windowWidth = $(window).width();
                var windowHeight = $(window).height();
                var scrollTop = $(window).scrollTop();

                // Initial position (above center of element)
                var left = elementPos.left + (elementWidth / 2) - (tooltipWidth / 2);
                var top = elementPos.top - tooltipHeight - 5;

                // Adjust if going out of viewport
                if (left < 10) {
                    left = 10;
                } else if (left + tooltipWidth > windowWidth - 10) {
                    left = windowWidth - tooltipWidth - 10;
                }

                if (top < scrollTop + 10) {
                    // If not enough space above, position below
                    top = elementPos.top + elementHeight + 10;
                }

                $tooltip.css({
                    left: left + 'px',
                    top: top + 'px'
                });
            }

            // Update position on scroll and resize
            $(window).on('scroll resize', function() {
                if ($tooltip.css('visibility') === 'visible') {
                    positionTooltip();
                }
            });
        });
    };
})(jQuery);